import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import FormWrapper from "./FormWrapper";
import { Row, Col, Button, Form } from "antd";
import { InputItem } from "../../../forms/FormItems";
import DateAndHourItem from "../../../forms/DateAndHourItem";
import {
  SettingsDataSelect,
  CrmUsersSelect,
} from "../../../forms/AutoCompleteFormItem";
import { useSelector } from "react-redux";
import ResponsiveItemsWrapper from "../../../layouts/ResponsiveItemsWrapper";
import Spacer from "../../../layouts/Spacer";
import { useCrm_task_priorities } from "../../../../hooks";
import {
  actionTypes,
  activityPriorities,
  activityTypes,
} from "../../constants";

const colLayout = { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 };

const TaskForm = ({ stretched, branchId, sider, branches, entity }) => {
  const form = Form.useFormInstance();
  const priorities = useCrm_task_priorities();
  const intl = useIntl();
  const createLoading = useSelector(
    (state) => state.pendingActions[actionTypes.ACTIVITY_CREATE]
  );
  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const [taskTypeId, setTaskTypeId] = React.useState(null);
  useEffect(() => {
    const priorityId = form.getFieldValue("priority_id");
    if (!priorityId && priorities?.length) {
      const normalPriorityId = priorities.find(
        (i) => i.name === activityPriorities.ACTIVITIES_PRIORITY_NORMAL
      ).id;
      form.setFieldValue("priority_id", normalPriorityId);
    }
  }, [form, priorities]);

  const handleTaskTypeChange = (value) => {
    setTaskTypeId(value);
    form.setFieldValue("sub_task_type_id", undefined);
  };

  const SelectComponents = (
    <ResponsiveItemsWrapper isSmall={true}>
      <div style={{ flex: 1 }}>
        <SettingsDataSelect
          name="priority_id"
          category="task"
          settingsdataName={"system_tables/crm/crm_task_priorities"}
          required={true}
          type="list"
          onChange={handleTaskTypeChange}
        />
      </div>
      <Spacer horizontal={true} />
      <div style={{ flex: 1 }}>
        <CrmUsersSelect
          name="assigned_to_id"
          category="tasks"
          extraParams={{
            scopePrefix: scopePrefix,
            filter: {},
            query: { branches: branches ? branches : [branchId] },
          }}
          required={true}
        />
      </div>
    </ResponsiveItemsWrapper>
  );
  const TaskTypeComponents = (
    <ResponsiveItemsWrapper isSmall={true}>
      <div style={{ flex: 1 }}>
        <SettingsDataSelect
          name="task_type_id"
          category="task"
          settingsdataName={"system_tables/crm_task_types"}
          extraParams={{
            current: 1,
            pageSize: 100,
            filter: {
              $and: [
                {
                  entity:
                    entity === "patients" || entity === "crm/patients"
                      ? "patient"
                      : "employee",
                },
              ],
            },
          }}
          type="list"
          onChange={handleTaskTypeChange}
        />
      </div>
      <Spacer horizontal={true} />
      <div style={{ flex: 1 }}>
        <SettingsDataSelect
          name="sub_task_type_id"
          category="task"
          settingsdataName={"system_tables/crm_sub_task_types"}
          extraParams={{
            current: 1,
            pageSize: 100,
            filter: { $and: [{ crm_task_type_id: taskTypeId }] },
          }}
          disabled={!taskTypeId}
          waitForFetch={!taskTypeId}
          type="list"
        />
      </div>
    </ResponsiveItemsWrapper>
  );

  const DateAndHourComponent = (
    <DateAndHourItem
      required={true}
      name="due_date"
      category="task"
      even={true}
    />
  );

  return (
    <div style={{ padding: "12px" }}>
      <Row>
        <Col {...colLayout} xxl={stretched ? 24 : 16}>
          <InputItem name="subject" category="task" required={true} />
          {SelectComponents}
          {TaskTypeComponents}
          {sider ? (
            DateAndHourComponent
          ) : (
            <ResponsiveItemsWrapper isSmall={true}>
              <div style={{ flex: 1 }}>{DateAndHourComponent}</div>
              <Spacer horizontal={true} /> <div style={{ flex: 1 }} />
            </ResponsiveItemsWrapper>
          )}
          <Button htmlType="submit" type="primary" loading={createLoading}>
            {intl.formatMessage({ id: "app.actions.submit" })}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

const Task = ({
  createActivity,
  statuses,
  refreshFormTimestamp,
  branches,
  ...props
}) => {
  const onSubmit = (values) => {
    const status = statuses.find((i) => i.name === "open");
    createActivity({
      activity: {
        ...values,
        type: activityTypes.ACTIVITIES_TYPE_TASK,
        status_id: status.id,
      },
      activityType: activityTypes.ACTIVITIES_TYPE_TASKS,
    });
  };
  return (
    <div className="activity_form">
      <FormWrapper
        onSubmit={onSubmit}
        refreshFormTimestamp={refreshFormTimestamp}
        activityType={activityTypes.ACTIVITIES_TYPE_TASK}
      >
        <TaskForm {...props} branches={branches} />
      </FormWrapper>
    </div>
  );
};

export default Task;
